import { Pipe, PipeTransform } from '@angular/core'

@Pipe({ name: 'optimizeCard' })
export class OptimizeCard implements PipeTransform {
	private width = 340 * 2
	private height = 136 * 2
	transform(
		url: string | undefined,
		output: 'jpg' | 'avif' | 'webp' = 'webp',
		width?: number,
		height?: number
	) {
		if (!url) {
			return ''
		}
		this.width = width ?? this.width
		this.height = height ?? this.height

		return `${url}?ims=${this.width}x${this.height}/filters:format(${output})`
	}
}
